<!-- No Data Template -->
<ng-template #no_data_template>
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
          {{ 'global.no_data' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Annotation Template -->
<ng-template #annotation_template
  let-annotation="annotation">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
        @if (annotation.type !== FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
          <i
          [class]="FlatModels.AnnotationEntityModels.AnnotationTypeIcon[annotation.type]"></i>
        }
        @if (annotation.type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
          <i
          [class]="FlatModels.AnnotationEntityModels.ShapeIcon[annotation.shape]"></i>
        }
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText">
          {{ slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async }}
        </span>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <p-tag 
          [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
          [value]="(annotation.images.length || 0).toString()" />
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
        <div class="flex flex-row column-gap-2 w-4rem">
          <div class="flex w-2rem">
            <button medsurf-design-input-button [id]="'annotation_go_to_' + annotation.id"
              [title]="'global.annotation_go_to' | translate"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCATE"
            (click)="goToAnnotation(annotation)"></button>
          </div>
          <div class="flex w-2rem">
            @if (annotation.images.length > 1) {
              <button medsurf-design-input-button
                [id]="'annotation_image_remove_' + annotation.id"
                [title]="'global.annotation_image_remove' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_SMALL_OUTLINED"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
              (click)="removeAnnotationFromImage(annotation)"></button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Content -->
<div class="flex flex-1 flex-column row-gap-2 mb-2">
  <label id="annotations_label"
    class="flex flex-grow-1 flex-row column-gap-2">
    <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
    <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
      {{ 'global.annotations' | translate }}
    </span>
  </label>
  <div [class]="FlatModels.TreeDesignModels.ItemListContainer">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if (slideAuthorFacade.currentSelectedSlideImage$ | async; as image) {
        @if (slideAuthorFacade.annotations$(image.annotations) | async | sortBy_shared:'asc':'sequenceNumber'; as annotations) {
          <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
            @if (image.annotations.length === 0) {
              <ng-container *ngTemplateOutlet="no_data_template"></ng-container>
            }
            @if (annotations.length === 0) {
              @for (i of image.annotations; track i) {
                <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                  class="cursor-wait"
                  >
                </p-skeleton>
              }
            }
            @if (annotations.length > 0) {
              <div>
                @for (annotation of annotations; track trackByAnnotation($index, annotation)) {
                <ng-container *ngTemplateOutlet="annotation_template;context:{
                              annotation: annotation}">
                  </ng-container>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>

  <!-- Image Annotation -->
  @if (imageAnnotationForm && imageAnnotationOptionArray && imageAnnotationOptionArray.length > 0) {
    <medsurf-design-form-control-form
      [formGroup]="imageAnnotationForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      <!-- Annotation -->
      <medsurf-design-form-control-input-dropdown [formField]="false"
        [control]="imageAnnotationForm.controls.id"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY_DROPDOWN"
        [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.SEPARATE_FIRST_ENTRY"
        [class]="'w-full align-self-start'"
        [placeholder]="'global.annotation_link'"
        [options]="imageAnnotationOptionArray"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
    </medsurf-design-form-control-form>
  }
</div>
